export const environment = {
    production: true,
    hmr: false,
    appMetadata: {
        appDomain: {
            title: 'friends.vn',
            owner: 'friends.vn',
            logo: 'assets/images/logo-dapfood-x-w.png',
        }
    },
    apiDomain: {
        gateway: 'https://api.friends.vn',
        authenticationEndpoint: 'https://account.friends.vn',
        authorizationEndpoint: 'https://api.friends.vn/authorization.api',
        fileEndpoint: 'https://api.friends.vn/file.api',
        notificationEndpoint: 'https://notification.friends.vn',
        dapFoodEndPoint: 'https://api.friends.vn/dapfood.api',
        dapSaleEndPoint: 'https://api.friends.vn/sale.api',
        dapEInvoiceEndPoint: 'https://api.friends.vn/dapeinvoice',
        logEndPoint: 'https://logs.friends.vn'
    },
    clientDomain: {
        appDomain: 'https://app.friends.vn',
        qthtDomain: 'https://admin.friends.vn',
        idPhanhe: 2,
    },
    authenticationSettings: {
        clientId: 'dapfood',
        issuer: 'https://account.friends.vn'
    },
    systemLogSetting: {
        enabled: false
    },
    signalr: {
        clientKey: 'dapfood',
        endpoint: '',
        linkDownloadClientApp: ''
    },
    signalrConfig: {
        hub: {
            notification: 'NotificationHub'
        },
        action: {
            notificationCreated: '',
            viewUpdated: ''
        }
    },
    firebaseConfig: {
        apiKey: 'AIzaSyBSkn5jUqD0N4PiiDEhsWyfPIws6TyNUho',
        authDomain: 'dapfood-firebase.firebaseapp.com',
        databaseURL: 'https://dapfood-firebase.firebaseio.com',
        projectId: 'dapfood-firebase',
        storageBucket: 'dapfood-firebase.appspot.com',
        messagingSenderId: '1088787441716',
        appId: '1:1088787441716:web:329c0dfd4356195f98c261',
        measurementId: 'G-RVEWV87V1P'
    }
}